import {useState}       from 'react';
import {Container, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, IconButton} from '@material-ui/core';
import {connect} from 'react-redux';
// Redux
import {changeView} from '../../redux/actions/Menu';
import {getInvoice, updateInvoice} from '../../redux/actions/Invoice';
// Values
import {Ic_edit, StateView, stateData} from '../../values';
import {formatMoney} from '../../utils';
// Components
import LoadingData      from '../global/LoadingData';
import Pagination       from '../global/ButtonsPagination';
// Styles
import {useStyles}          from '../../style';
// Api
import {getData}    from '../../utils/invoice';

const Tables = ({data, status, token, records, changeView, getInvoice, updateInvoice}) => {
    const classes = useStyles()
    const [page,setPage]    = useState(1)

    const edit = (item) => {
        changeView(StateView.state3)
        updateInvoice(item)
    }
    const GetData = async(page) =>{
        const res = await getData(token, `?Page=${page}`)
        getInvoice(res.data)
        window.scrollTo(0, 0)
    }
    const changePage = (e,v) =>{
        setPage(v)
        GetData(v)
    }
    return (
        <div style={{position:'relative'}}>
            {
                status===stateData.state2?
                    <Container maxWidth="xl">
                        <TableContainer style={{background:'#fff'}}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow style={{background:'#132327', height:50}}>
                                        {
                                            ['Nombre legal', 'Uso', 'Id del servicio', 'Total', 'Editar'].map((item, index) =>
                                                <TableCell align="center" key={index} className={classes.table_title2} style={{fontFamily:'bold', color:'#fff'}}> {item} </TableCell>
                                            )
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data&&
                                        data.map((item, index) =>(
                                            <TableRow key={index} style={{borderBottom:`1px solid #f3f4f7`}}>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>{item.LegalName}</TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>{item.InvoiceUse}</TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>{item.IdService}</TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>$ {formatMoney(item.TotalService)} MXN</TableCell>
                                                <TableCell align="center" className={classes.table_text2}>
                                                    <IconButton onClick={() => edit(item)}>
                                                        <img alt="ic_edit" src={Ic_edit} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Pagination records={records} page={page} changePage={changePage} />
                    </Container>
                :
                    <LoadingData />
            }
        </div>
    );
};
const mapStateToProps = state =>({
    data:       state.Invoice.invoice,
    status:     state.Invoice.status,
    token:      state.Panel.token,
    records:    state.Invoice.records
})

export default connect(mapStateToProps, {changeView, getInvoice, updateInvoice})(Tables);
